<template>
  <h1 class="section-heading"><slot/></h1>
</template>

<script>
export default {
  name: 'SectionHeading'
}
</script>

<style lang="scss" scoped>
@import '../../assets/sass/config';

.section-heading {
  font-size: 2rem;
  font-weight: 900;
  padding: 0;
  margin: 0;
  line-height: 1.2;
  /* text-transform: uppercase; */
  text-align: center;
  color: $text-color;

  @media (max-width: 568px) {
    font-size: 1.5rem;
  }
}
</style>

